import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-customer-overview',
  templateUrl: './add-customer-overview.component.html',
  styleUrls: ['./add-customer-overview.component.scss']
})
export class AddCustomerAdminOverviewComponent implements OnInit {
  /**
   * Add a user with an ERP-Sync
   */
  withERP = 'withERP';
  /**
   * Add a user without an ERP-Sync
   */
  noERP = 'noERP';
  /**
   * ngOnInit
   */
  constructor() { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
  }

}
